/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impressum_Address_PlaceholderInputs */

const en_impressum_address_placeholder = /** @type {(inputs: Impressum_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koppoldstr. 1, 86551 Aichach, Germany`)
};

const de_impressum_address_placeholder = /** @type {(inputs: Impressum_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koppoldstr. 1, 86551 Aichach, Deutschland`)
};

const fr_impressum_address_placeholder = /** @type {(inputs: Impressum_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koppoldstr. 1, 86551 Aichach, Germany`)
};

const es_impressum_address_placeholder = /** @type {(inputs: Impressum_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koppoldstr. 1, 86551 Aichach, Germany`)
};

const it_impressum_address_placeholder = /** @type {(inputs: Impressum_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koppoldstr. 1, 86551 Aichach, Germany`)
};

const nl_impressum_address_placeholder = /** @type {(inputs: Impressum_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koppoldstr. 1, 86551 Aichach, Germany`)
};

const pl_impressum_address_placeholder = /** @type {(inputs: Impressum_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koppoldstr. 1, 86551 Aichach, Germany`)
};

const fi_impressum_address_placeholder = /** @type {(inputs: Impressum_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koppoldstr. 1, 86551 Aichach, Germany`)
};

const da_impressum_address_placeholder = /** @type {(inputs: Impressum_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koppoldstr. 1, 86551 Aichach, Germany`)
};

const sv_impressum_address_placeholder = /** @type {(inputs: Impressum_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koppoldstr. 1, 86551 Aichach, Germany`)
};

/**
* | output |
* | --- |
* | "Koppoldstr. 1, 86551 Aichach, Germany" |
*
* @param {Impressum_Address_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const impressum_address_placeholder = /** @type {((inputs?: Impressum_Address_PlaceholderInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impressum_Address_PlaceholderInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_impressum_address_placeholder(inputs)
	if (locale === "fr") return fr_impressum_address_placeholder(inputs)
	if (locale === "es") return es_impressum_address_placeholder(inputs)
	if (locale === "it") return it_impressum_address_placeholder(inputs)
	if (locale === "nl") return nl_impressum_address_placeholder(inputs)
	if (locale === "pl") return pl_impressum_address_placeholder(inputs)
	if (locale === "fi") return fi_impressum_address_placeholder(inputs)
	if (locale === "da") return da_impressum_address_placeholder(inputs)
	if (locale === "sv") return sv_impressum_address_placeholder(inputs)
	return en_impressum_address_placeholder(inputs)
});